/**
 * 当前登录用户信息类
 * @author Jianbo
 * @time   2020-03-13
 */
class AccountModel {
  id = 0

  nickname = ''

  sex = 0

  avatar = ''

  /**
   * 构造函数
   */
  constructor (params) {
    this.setData(params)
  }

  /**
   * 设置属性
   * @param  Object  obj  属性对象, 如: {id: 10001}
   * @return Class   this
  */
  setData (obj = {}) {
    Object.keys(obj).forEach((k) => {
      if (typeof obj[k] !== 'function') this[k] = obj[k]
    })
    return this
  }

  format () {
    return this
  }
}

export default AccountModel
